import { Component } from "react";
import * as React from "react";
import { PrimaryButton } from "office-ui-fabric-react";

interface TablePagingProps {
    total?: number;
    count?: number;
    next: (() => void) | undefined;
    previous: (() => void) | undefined;
}

interface TablePagingState {

}

export default class TablePaging extends Component<TablePagingProps, TablePagingState>
{
    private getButton(link: (() => void) | undefined, text: string): JSX.Element {
        if (link !== undefined) {
            return <PrimaryButton text={text} onClick={() => link()} />
        }
        else{
            return <PrimaryButton text={text} disabled={true} />
        }
    }

    public render() {
        return (
            <div className={`flex-row flex--align-items-center flex--justify-content-center`}>
                <div className={`p-05rem`}>
                    {this.getButton(this.props.previous, "Previous")}
                </div>
                <div className={`p-05rem`}>
                    {this.props.count} / {this.props.total}
                </div>
                <div className={`p-05rem`}>
                    {this.getButton(this.props.next, "Next")}
                </div>
            </div>
        );
    }
}